import { createSlice } from "@reduxjs/toolkit";

interface ReviewPageInterface {
    currentPage: number;
    itemsPerPage: number;
    searchTerm: string;
    itemsPerPageSelect: { value: number; activeValue: boolean }[];
    acceptIsLoading: boolean;
    currentProcessingId?: number;
    isReviewCertificateSuccess: boolean;
    isLeftTagModalOpenIndex?: number;
    isRightTagModalOpenIndex?: number;
}

const initialState: ReviewPageInterface = {
    currentPage: 1,
    itemsPerPage: 12,
    searchTerm: "",
    itemsPerPageSelect: [
        { value: 12, activeValue: true },
        { value: 25, activeValue: false },
        { value: 50, activeValue: false },
    ],
    acceptIsLoading: false,
    isReviewCertificateSuccess: false,
    isLeftTagModalOpenIndex: -1,
    isRightTagModalOpenIndex: -1,
};

const reviewSlice = createSlice({
    name: "review",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setItemsPerPage: (state, action) => {
            state.itemsPerPage = action.payload;

            state.itemsPerPageSelect = state.itemsPerPageSelect.map((item) => {
                return {
                    ...item,
                    activeValue: item.value === action.payload,
                };
            });
        },
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },
        setAcceptIsLoading: (state, action) => {
            state.acceptIsLoading = action.payload;
        },
        setCurrentProcessingId: (state, action) => {
            state.currentProcessingId = action.payload;
        },
        setIsReviewCertificateSuccess: (state, action) => {
            state.isReviewCertificateSuccess = action.payload;
        },
        setIsLeftTagModalOpenIndex: (state, action) => {
            state.isLeftTagModalOpenIndex = action.payload;
        },
        setIsRightTagModalOpenIndex: (state, action) => {
            state.isRightTagModalOpenIndex = action.payload;
        },
    },
});

export const reviewReducer = reviewSlice.reducer;

export const {
    setItemsPerPage,
    setCurrentPage,
    setSearchTerm,
    setAcceptIsLoading,
    setCurrentProcessingId,
    setIsReviewCertificateSuccess,
    setIsRightTagModalOpenIndex,
    setIsLeftTagModalOpenIndex,
} = reviewSlice.actions;
